import { MdClear } from "react-icons/md";
import SelectCampaign from "./SelectCampaign";
import { useState } from "react";
import useCampaigns from "../useCampaign";

const CreateCampaign = ({ onClose, handleSnackbar }) => {
  const [formData, setFormData] = useState({
    campaignName: "",
    couponCode: "",
    startDate: "",
    endDate: "",
  });

  const { submitCampaign } = useCampaigns();

  const validateForm = () =>
    formData.campaignName.trim().length >= 3 &&
    formData.couponCode.trim().length >= 4 &&
    formData.startDate &&
    formData.endDate &&
    new Date(formData.endDate) > new Date(formData.startDate);

  const handleSubmit = async () => {
    try {
      const response = await submitCampaign({
        name: formData.campaignName,
        couponCode: formData.couponCode,
        startDate: new Date(formData.startDate).toISOString(),
        endDate: new Date(formData.endDate).toISOString(),
      });
      if (response) {
        handleSnackbar("Campaign created successfully!");
        onClose();
      } else {
        handleSnackbar("An unexpected error occurred", "error");
      }
    } catch (error) {
      console.error("Error submitting campaign:", error);
      handleSnackbar(
        `An unexpected error occurred: ${error?.message ?? error}`,
        "error"
      );
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex justify-between items-center bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 p-4 rounded-t-lg">
        <h2 className="text-2xl font-bold text-white">Create Campaign</h2>
        <button onClick={onClose} className="text-xl text-white">
          <MdClear />
        </button>
      </div>

      {/* Content */}
      <div className="p-4 md:p-6">
        <SelectCampaign formData={formData} setFormData={setFormData} />

        <div className="flex justify-end mt-6">
          <button
            type="button"
            disabled={!validateForm()}
            onClick={handleSubmit}
            className={`px-4 py-2 rounded-md ${
              validateForm()
                ? "bg-green-500 text-white hover:bg-green-600"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Create Campaign
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaign;
